import React, { useEffect, useState } from "react";
import { Button, Layout, Space, Table, Tag, Typography, Alert, Row, Input, Col, Divider, Select, Card, Collapse, DatePicker } from 'antd';
import { EyeOutlined, CaretLeftOutlined, CaretRightOutlined, UsergroupAddOutlined, FilterOutlined } from '@ant-design/icons';
import { Link, useNavigate } from "react-router-dom";
import { inject, observer } from 'mobx-react'
import { cloneDeep } from "lodash";
import moment from "moment-timezone";
import "./style.scss";

const { Content } = Layout;
const { Title, Text } = Typography;

const CustomEvents = ({ userStore, eventStore }) => {
  
  const navigate = useNavigate()
  const { RangePicker } = DatePicker;
  const { Panel } = Collapse;

  const [selectedDates, setSelectedDates] = useState([]);

  useEffect(() => {
    eventStore.page = 1;
    eventStore.hasMore = false;
    eventStore.perPage = 10;
    eventStore.fetchEvents();
  }, []);

  const handlePrevPage = () => {
    eventStore.page = eventStore.page - 1;
    eventStore.fetchEvents();
  };

  const handleNextPage = () => {
    eventStore.page = eventStore.page + 1;
    eventStore.fetchEvents();
  };



  const columns = [
    {
      title: 'Event Name',
      key: 'EventName+ID',
      dataIndex: 'EventName',
      responsive: ['lg', 'xl', 'md'],
      render: (EventName) => (
        <Text default>{EventName}</Text>
      )
    },
    {
      title: 'Location',
      key: 'Location+ID',
      dataIndex: 'Location',
      responsive: ['lg', 'xl', 'md'],
      render: (Location) => (
        <Text default>{Location}</Text>
      )
    },
    {
      title: 'Date',
      key: 'Date+EventID',
      dataIndex: 'Date',
      render: (Date, record) => {
        return <Text>{moment(Date).format("MMM DD, YYYY")}</Text>;
      }
    },
    {
      title: 'TotalAmt',
      dataIndex: 'TotalAmount',
      key: 'TotalAmount+ID',
      render: (TotalAmount) => (
        <Text strong>₱{formatNumber(TotalAmount)}</Text>
      )
    },
    {
      title: 'Created By',
      dataIndex: 'CreatedBy',
      key: 'CreatedBy+ID',
      render: (CreatedBy) => (
        <Text default>{CreatedBy}</Text>
      )
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => (
        <Space size={'small'}>
          <Link to={'/events/'+record.EventID}><Button icon={<EyeOutlined/>} type="primary" ghost>View</Button></Link>
        </Space>
      )
    },
  ];

  const handleDateChange = (dates) => {

    setSelectedDates(dates);

  };

  const handleCalculateAmount = () => {
    if (!selectedDates || selectedDates.length !== 2) {
      console.error("Please select a valid date range.");
      return;
    }

    const startDate = selectedDates[0].format("YYYY-MM-DD");
    const endDate = selectedDates[1].format("YYYY-MM-DD");

    eventStore.fetchEventsCalculate(startDate, endDate);
  };

  const formatNumber = (formatnumber) => {
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(formatnumber);
  };

  return (
    <div className="admin-list-events">
      <Content>
        <div className="admin-content-voters">
          <Row justify={"space-between"} align={"middle"}>
            <Title level={4}>Events List</Title>
            <Button 
              type="primary" 
              icon={<UsergroupAddOutlined /> }
              onClick={() => navigate('add')}
            >Add Event</Button>
          </Row>
          <Row justify={"space-between"} align={"middle"}>
          </Row>
          <Alert
            message="List of Events"
            description="List of your registered voters. If you think there's a problem with the list of users, please contact an administrator for assistance."
            type="info"
            showIcon
          />
          <Alert
            message="Calculate Amount"
            description="Please select a Start Date and End Date to calculate events total amount."
            type="warning"
            showIcon
          />
          <Row gutter={15}>
            <Col>
              <RangePicker onChange={handleDateChange}/>  
            </Col>
            <Col>
              <Button type="primary" icon={<FilterOutlined />} onClick={handleCalculateAmount}>Calculate Amount</Button>
            </Col>
          </Row>
          <Row className="admin-ayuda-header-eventadmin" >
            <Col span={8}>
              <Card>
                <Title level={5}>Total Distributed Ayuda</Title>
                <Text type="secondary">This shows the total amount distributed during the event by the District Coordinators to all voters.</Text>
                <Row justify={"space-between"}>
                  <Col><Title level={3}>₱ {formatNumber(eventStore.eventsTotalAmount)}</Title></Col>
                </Row>
              </Card>
            </Col>
          </Row>
          <Table pagination={false} columns={columns} dataSource={cloneDeep(eventStore.events)} bordered/>
          <ul className="pagination">
            <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPage} disabled={eventStore.page == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
            <li className="pagination-item"><a>{eventStore.page}</a></li>
            <li className="pagination-next "><Button type="dashed" onClick={handleNextPage} disabled={eventStore.hasMore ? false : true}>Next<CaretRightOutlined /></Button></li>
          </ul>
        </div>
      </Content>
    </div>

  );
};

export default inject('userStore', 'eventStore')(observer(CustomEvents));
